import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import styles from './ApplePayButton.module.scss';
import messages from '../forms/SteppedPaymentForm/messages';
import useApplePaySession from '../../hooks/useApplePaySession';
import { UseApplePaySessionResult } from './types';
import { CheckoutFormData } from '../../blocks/Checkout/SteppedCheckout/types';

const ApplePayButton = ({
  onCompleteCheckout = undefined,
  isExpressCheckout = false,
  isSteppedCheckout = false
}: {
    onCompleteCheckout?: (data: CheckoutFormData) => Promise<void>;
    isExpressCheckout?: boolean;
    isSteppedCheckout?: boolean;
}) => {
  const { formatMessage } = useIntl();
  const { completeOrderCallback, isApplePayAvailable } =
    useApplePaySession() as UseApplePaySessionResult;

  const handleApplePayButton = useCallback(() => {
    completeOrderCallback({
      completeOrderFunction: onCompleteCheckout,
      isExpressCheckout,
    });
  }, [completeOrderCallback, isExpressCheckout, onCompleteCheckout]);

  if (!isApplePayAvailable) return null;

  return (
      <button
        type="button"
        aria-label={formatMessage(messages.applePayLogoAlt)}
        onClick={handleApplePayButton}
        className={classNames(styles['apple-pay-button-wrapper'], {
        [styles['apple-pay-express-button-wrapper']]: isSteppedCheckout
      })}
      >
        <div className={classNames({
          [styles.applelogo]: !isSteppedCheckout,
          [styles['applelogo-small']]: isSteppedCheckout
        })} />
      </button>
  );
};

export default ApplePayButton;
